import * as React from 'react';
import { BreadcrumbContext } from './BreadcrumbProvider';

export const useBreadcrumbContext = () => {
  const context = React.useContext(BreadcrumbContext);

  if (context === undefined) {
    throw new Error('useBreadcrumbContext must be used within an OnboardingProvider');
  }

  return context;
};

export default useBreadcrumbContext;
